<template>
  <div>
    <div class="card mb-3" v-if="isScreen != 3">
      <div class="card-body">
        <h4 class="card-title text-center text-primary text-uppercase">
          <!-- ĐĂNG KÝ XÉT TUYỂN THEO HỌC BẠ THPT 2020 -->
          {{ review }} {{ $t("models.thiSinh.titledangKy") }} {{ title }}
        </h4>
      </div>
    </div>
    <ValidationObserver ref="form" v-show="isScreen == 1">
      <form @submit.prevent="dangKy" v-if="dotdangky.loaiDot && dotdangky.loaiDot != 'CAOHOC'">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title text-uppercase">
              {{ $t("models.thiSinh.titleCard1") }}
            </h5>
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="txtHoTen">
                  {{ $t("models.thiSinh.hoTen") }}:
                </label>
                <validation-provider
                  :name="$t('models.thiSinh.hoTen')"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtHoTen"
                    class="form-control"
                    v-model="thisinh.hoTen"
                    v-focus
                    :placeholder="$t('models.thiSinh.hoTen')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-4 mb-3">
                <label for="txtNgaySinh">
                  {{ $t("models.thiSinh.ngaySinh") }}:
                </label>
								<validation-provider rules="required" :name="$t('models.thiSinh.ngaySinh')" v-slot="{ errors, valid }">
									<date-picker
										id="txtNgaySinh"
										:value="thisinh.ngaySinh"
										:placeholder="$t('models.thiSinh.ngaySinh')"
										:classes="{
											'is-invalid': errors[0],
											'is-valid': valid,
										}"
										@callbackFunction="(value) => (thisinh.ngaySinh = value)"
									></date-picker>
									<span class="text-danger">{{ errors[0] }}</span>
								</validation-provider>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4 mb-3" v-if="loaiDot == 'THPT'">
                <label for="txtSoCMND">{{ $t("models.thiSinh.cmnd") }}:</label>
                <validation-provider
                  :name="$t('models.thiSinh.cmnd')"
                  :rules="`required|checkExistCmnd:${thisinh.thiSinhId},${soCmnd}`"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtSoCMND"
                    class="form-control"
                    v-model="thisinh.soCmnd"
                    :placeholder="$t('models.thiSinh.cmnd')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-6 mb-3" v-else>
                <label for="txtSoCMND">{{ $t("models.thiSinh.cmnd") }}:</label>
                <validation-provider
                  :name="$t('models.thiSinh.cmnd')"
                  :rules="`required|checkExistCmnd:${thisinh.thiSinhId},${soCmnd}`"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtSoCMND"
                    class="form-control"
                    v-model="thisinh.soCmnd"
                    :placeholder="$t('models.thiSinh.cmnd')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-4 mb-3">
                <p for="txtGioiTinh" class="pr-5">
                  {{ $t("models.thiSinh.gioiTinh") }}:
                </p>
                <validation-provider
                  :name="$t('models.thiSinh.gioiTinh')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      checked
                      :value="$t('models.thiSinh.nam')"
                      v-model="thisinh.gioiTinh"
                    />
                    <label class="form-check-label" for="Nam">
                      {{ $t("models.thiSinh.nam") }}
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      :value="$t('models.thiSinh.nu')"
                      v-model="thisinh.gioiTinh"
                    />
                    <label class="form-check-label">
                      {{ $t("models.thiSinh.nu") }}
                    </label>
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-4 mb-3" v-if="loaiDot == 'THPT'">
                <label for="txtSbd">{{ $t("models.thiSinh.sbd") }}:</label>
                <validation-provider
                  :name="$t('models.thiSinh.sbd')"
                  :rules="`required|checkExistSbd:${thisinh.thiSinhId},${sbd}`"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtSbd"
                    class="form-control"
                    v-model="thisinh.sbd"
                    :placeholder="$t('models.thiSinh.sbd')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4 mb-3">
                <label for="txtSoDienThoai">
                  {{ $t("models.thiSinh.sdt") }}:
                </label>
                <validation-provider
                  rules="numeric|length:10"
                  :name="$t('models.thiSinh.sdt')"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="number"
                    id="txtSoDienThoai"
                    class="form-control"
                    v-model="thisinh.soDienThoai"
                    :placeholder="$t('models.thiSinh.sdt')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-4 mb-3">
                <label for="txtEmail">{{ $t("models.thiSinh.email") }}:</label>
                <validation-provider
                  rules="required|email"
                  :name="$t('models.thiSinh.email')"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="email"
                    id="txtEmail"
                    class="form-control"
                    v-model="thisinh.email"
                    :placeholder="$t('models.thiSinh.email')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-4 mb-3">
                <label for="ddlDoiTuong">
                  {{ $t("models.thiSinh.doiTuong") }}:
                </label>
                <validation-provider
                  rules="required"
                  :name="$t('models.thiSinh.doiTuong')"
                  v-slot="{ errors, valid }"
                >
                  <select
                    class="form-control"
                    id="ddlDoiTuong"
                    v-model="thisinh.maDoiTuong"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  >
                    <option value="00">
                      {{ $t("models.thiSinh.notUuTien") }}
                    </option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4 mb-3">
                <label for="ddlKhuVuc">
                  {{ $t("models.thiSinh.khuVuc") }}:
                </label>
                <validation-provider
                  rules="required"
                  :name="$t('models.thiSinh.khuVuc')"
                  v-slot="{ errors, valid }"
                >
                  <select
                    class="form-control"
                    v-model="thisinh.maKhuVuc"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    :placeholder="$t('models.thiSinh.khuVuc')"
                    id="ddlKhuVuc"
                  >
                    <option value="KV1">KV1</option>
                    <option value="KV2">KV2</option>
                    <option value="KV2NT">KV2NT</option>
                    <option value="KV3">KV3</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-8 mb-3">
                <label for="txtHoKhau">
                  {{ $t("models.thiSinh.diaChi") }}:
                </label>
                <validation-provider
                  rules="required"
                  :name="$t('models.thiSinh.diaChi')"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtHoKhau"
                    class="form-control"
                    v-model="thisinh.hoKhau"
                    :placeholder="$t('models.thiSinh.diaChi')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-3">
          <div class="card-body">
            <h5 class="card-title text-uppercase">
              {{ $t("models.thiSinh.titleCard2") }}
            </h5>
            <ThongTinTHPT
              v-for="item in [10, 11, 12]"
              :key="item"
              :lop="item"
            ></ThongTinTHPT>
          </div>
        </div>

        <div class="card mt-3">
          <div class="card-body">
            <h5 class="card-title text-uppercase">
              {{ $t("models.thiSinh.titleCard3") }}
            </h5>
            <div class="form-row">
              <div class="col-md-12 mb-3">
                <label for="txtDiaChiLienHe">
                  {{ $t("models.thiSinh.dcLienHe") }} :
                </label>
                <validation-provider
                  :name="$t('models.thiSinh.dcLienHe')"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtDiaChiLienHe"
                    class="form-control"
                    v-model="thisinh.diaChi"
                    :placeholder="$t('models.thiSinh.dcLienHe')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4 mb-3">
                <label for="txtHoTenBo">
                  {{ $t("models.thiSinh.hoTenBo") }} :
                </label>
                <validation-provider
                  :name="$t('models.thiSinh.hoTenBo')"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtHoTenBo"
                    class="form-control"
                    v-model="thisinh.hoTenBo"
                    :placeholder="$t('models.thiSinh.hoTenBo')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-4 mb-3">
                <label for="txtSDTBo">
                  {{ $t("models.thiSinh.sdtBo") }}:
                </label>
                <validation-provider
                  :name="$t('models.thiSinh.sdtBo')"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="number"
                    id="txtSDTBo"
                    class="form-control"
                    v-model="thisinh.sdtbo"
                    :placeholder="$t('models.thiSinh.sdtBo')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4 mb-3">
                <label for="txtHoTenMe">
                  {{ $t("models.thiSinh.hoTenMe") }}:
                </label>
                <validation-provider
                  :name="$t('models.thiSinh.hoTenMe')"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtHoTenMe"
                    class="form-control"
                    v-model="thisinh.hoTenMe"
                    :placeholder="$t('models.thiSinh.hoTenMe')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="col-md-4 mb-3">
                <label for="txtSDTMe">{{ $t("models.thiSinh.sdtMe") }}:</label>
                <validation-provider
                  :name="$t('models.thiSinh.sdtMe')"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="number"
                    id="txtSDTMe"
                    class="form-control"
                    v-model="thisinh.sdtme"
                    :placeholder="$t('models.thiSinh.sdtMe')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-3">
          <div class="card-body">
            <h5 class="card-title text-uppercase">
              {{ $t("models.thiSinh.titleCard4") }}
            </h5>
            <!-- Học bạ -->
            <div class="col-md-6 mb-3" v-if="loaiDot == 'HOCBA'">
              <label for="txtHoTen">
                {{ $t("models.thiSinh.scanHocBa") }}:
              </label>
              <validation-provider
                rules="required"
                :name="$t('models.thiSinh.scanHocBa')"
                v-slot="{ errors, valid }"
                v-if="!checkTypeFile(thisinh.fileHocBa, 'hoc_ba')"
              >
                <v-file-input
                  outlined
                  dense
                  chips
                  multiple
                  v-model="fileHocBa"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider
                :name="$t('models.thiSinh.scanHocBa')"
                v-slot="{ errors, valid }"
                v-if="checkTypeFile(thisinh.fileHocBa, 'hoc_ba')"
              >
                <div class="message-file">
                  <span class="text-danger">
                    {{ $t("models.thiSinh.notUploadHocBa") }}
                  </span>
                  <a
                    class="
                      font-weight-bold
                      text-primary text-decoration-underline
                    "
                    style="cursor: pointer"
                    @click="clickDownFileHoSo(dotdangkythisinh.thiSinhId)"
                  >
                    {{ $t("button.taiDay") }}
                  </a>
                </div>
                <v-file-input
                  outlined
                  dense
                  chips
                  multiple
                  v-model="fileHocBa"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- End Học bạ -->

            <!-- Thi -->
            <div class="col-md-6 mb-3" v-if="loaiDot == 'THI'">
              <label for="txtHoTen">
                {{ $t("models.thiSinh.scanHoSo") }}:
              </label>
              <validation-provider
                rules="required"
                :name="$t('models.thiSinh.scanHoSo')"
                v-slot="{ errors, valid }"
                v-if="!checkTypeFile(thisinh.fileHocBa, 'ho_so_thi')"
              >
                <v-file-input
                  outlined
                  dense
                  chips
                  multiple
                  v-model="fileHocBa"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider
                :name="$t('models.thiSinh.scanHoSo')"
                v-slot="{ errors, valid }"
                v-if="checkTypeFile(thisinh.fileHocBa, 'ho_so_thi')"
              >
                <span class="message-file">
                  <span class="text-danger">
                    {{ $t("models.thiSinh.notUploadHoSo") }}
                  </span>
                  <a
                    class="
                      font-weight-bold
                      text-primary text-decoration-underline
                    "
                    style="cursor: pointer"
                    @click="clickDownFileHoSo(dotdangkythisinh.thiSinhId)"
                  >
                    {{ $t("button.taiDay") }}
                  </a>
                </span>
                <v-file-input
                  outlined
                  dense
                  chips
                  multiple
                  v-model="fileHocBa"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- end Thi -->

            <!-- KQ THPT -->
            <div class="col-md-6 mb-3" v-if="loaiDot == 'THPT'">
              <label for="txtHoTen">
                {{ $t("models.thiSinh.scanKQTHPT") }}:
              </label>
              <validation-provider
                rules="required"
                :name="$t('models.thiSinh.scanKQTHPT')"
                v-slot="{ errors, valid }"
                v-if="!checkTypeFile(thisinh.fileHocBa, 'kq_thi_thpt')"
              >
                <v-file-input
                  outlined
                  dense
                  chips
                  multiple
                  v-model="fileHocBa"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider
                :name="$t('models.thiSinh.scanKQTHPT')"
                v-slot="{ errors, valid }"
                v-if="checkTypeFile(thisinh.fileHocBa, 'kq_thi_thpt')"
              >
                <span class="message-file">
                  <span class="text-danger">
                    {{ $t("models.thiSinh.notUploadKQTHPT") }}
                  </span>
                  <a
                    class="
                      font-weight-bold
                      text-primary text-decoration-underline
                    "
                    style="cursor: pointer"
                    @click="clickDownFileHoSo(dotdangkythisinh.thiSinhId)"
                  >
                    {{ $t("button.taiDay") }}
                  </a>
                </span>
                <v-file-input
                  outlined
                  dense
                  chips
                  multiple
                  v-model="fileHocBa"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- end KQ THPT -->

            <div v-if="loaiDot != 'THI'" class="col-12">
              <nguyen-vong
                v-for="(nguyenvong, index) in nguyenvongs"
                :key="index"
                :stt="index"
                :length="nguyenvongs.length"
                :nganhId="nguyenvong.nganhId"
                :loaiDot="loaiDot"
              ></nguyen-vong>
            </div>

            <div v-else class="col-md-12 mb-3">
              <nguyen-vong
                v-for="(nguyenvong, index) in nguyenvongs"
                :key="index"
                :stt="index"
                :length="nguyenvongs.length"
                :nganhId="nguyenvong.nganhId"
                :loaiDot="loaiDot"
              ></nguyen-vong>
            </div>

            <div class="row" v-if="loaiDot != 'THI'">
              <v-col cols="2" sm="3">
                <div class="my-2">
                  <v-btn
                    class="ma-2"
                    large
                    color="success"
                    dark
                    @click="themNguyenVong"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    {{ $t("button.addNguyenVong") }}
                  </v-btn>
                </div>
              </v-col>
            </div>
          </div>
        </div>

        <div class="mt-3" v-if="loaiDot != 'THI'">
          <table class="table table-bordered" v-if="loaiDot == 'HOCBA'">
            <thead>
              <tr>
                <th>{{ $t("models.monHoc.title") }}</th>
                <th>{{ $t("models.diem.title10") }}</th>
                <th>{{ $t("models.diem.title11") }}</th>
                <th>{{ $t("models.diem.title12") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="diem in diems" :key="diem.tenMonHoc">
                <td>{{ diem.tenMonHoc }}</td>
                <td>
                  <validation-provider
                    :name="$t('models.diem.name10', { data: diem.tenMonHoc })"
                    rules="between:1,10|required"
                    v-slot="{ errors, valid }"
                  >
                    <input
                      type="number"
                      class="form-control"
                      pattern="^\d*(\.\d{0,2})?$"
                      step="0.01"
                      v-model="diem.diem1"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-provider>
                </td>
                <td>
                  <validation-provider
                    :name="$t('models.diem.name11', { data: diem.tenMonHoc })"
                    rules="between:1,10|required"
                    v-slot="{ errors, valid }"
                  >
                    <input
                      type="number"
                      class="form-control"
                      pattern="^\d*(\.\d{0,2})?$"
                      step="0.01"
                      v-model="diem.diem2"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-provider>
                </td>
                <td>
                  <validation-provider
                    :name="$t('models.diem.name12', { data: diem.tenMonHoc })"
                    rules="between:1,10|required"
                    v-slot="{ errors, valid }"
                  >
                    <input
                      type="number"
                      class="form-control"
                      pattern="^\d*(\.\d{0,2})?$"
                      step="0.01"
                      v-model="diem.diem3"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-provider>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- DIEM THI THPT -->
          <table class="table table-bordered" v-if="loaiDot == 'THPT'">
            <thead>
              <tr>
                <th>{{ $t("models.monHoc.title") }}</th>
                <th>{{ $t("models.diem.title") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="diem in diems" :key="diem.tenMonHoc">
                <td>{{ diem.tenMonHoc }}</td>
                <td>
                  <validation-provider
                    :name="$t('models.diem.name', { data: diem.tenMonHoc })"
                    rules="between:1,10|required"
                    v-slot="{ errors, valid }"
                  >
                    <input
                      type="number"
                      class="form-control"
                      pattern="^\d*(\.\d{0,2})?$"
                      step="0.01"
                      v-model="diem.diemM"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-provider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="form-row mt-3">
          <div class="col-3">
            <button
              class="btn btn-success form-control"
              v-if="screenAction == 'DangKy'"
            >
              {{ $t("button.dangKy") }}
            </button>
            <button class="btn btn-success form-control" v-else>
              {{ $t("button.chinhSua") }}
            </button>
          </div>
        </div>
      </form>
			<dang-ky-cao-hoc v-if="dotdangky.loaiDot && dotdangky.loaiDot == 'CAOHOC'" @comeBack="isScreen = 2" :screenAction="screenAction"></dang-ky-cao-hoc>
    </ValidationObserver>

    <thong-tin-dang-ky
      v-if="isScreen == 2 && dotdangky.loaiDot != 'CAOHOC'"
      @comeBack="comeBack"
      :screenAction="screenAction"
      :file="fileHocBa"
      :loaiDot="loaiDot"
    ></thong-tin-dang-ky>
    <thong-tin-dang-ky-cao-hoc
      v-if="isScreen == 2 && dotdangky.loaiDot == 'CAOHOC'"
      @comeBack="comeBack"
      :screenAction="screenAction"
      :file="fileHocBa"
      :loaiDot="loaiDot"
    ></thong-tin-dang-ky-cao-hoc>
    <thong-bao-thanh-cong v-if="isScreen == 3"></thong-bao-thanh-cong>
    <dialog-loader ref="dialogLoader"></dialog-loader>
  </div>
</template>
<script>
import DangKy from "../js/dangky";
export default DangKy;
</script>

<style scoped>
.md-form label {
  color: darkgreen;
}
</style>
